"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = __importDefault(require("bignumber.js"));
class RoleCostRateCalculator {
    constructor() { }
    calculateStandardRate(totalRoleCost, totalRoleHours) {
        if (totalRoleHours.isLessThanOrEqualTo(0)) {
            throw new Error('Expected total role hours > 0');
        }
        return totalRoleCost.dividedBy(totalRoleHours);
    }
    calculateOverheadRate(totalBillableHours, nonBillableRoleCosts) {
        if (totalBillableHours.isLessThanOrEqualTo(0)) {
            throw new Error('Expected total billable hours > 0');
        }
        return nonBillableRoleCosts.reduce((total, current) => total.plus(current.dividedBy(totalBillableHours)), new bignumber_js_1.default(0));
    }
    calculateLoadedCost(standardRate, overheadRates) {
        return overheadRates.reduce((acc, r) => acc.plus(r), standardRate);
    }
    calculateTotalCost(loadedCost, hours) {
        return loadedCost.multipliedBy(hours);
    }
}
exports.default = RoleCostRateCalculator;
//# sourceMappingURL=RoleCostRateCalculator.js.map